module.exports = __webpack_public_path__ + "static/media/Street_cleaner.39a2d940.mp3";